module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1153.365f0823.png";